import React from 'react';
import UI from '../../commons/services/UI';
import { openBillingPage, isPremium } from '../../commons/services/Wix';
import PanelTabs from '../../commons/components/PanelTabs';
import createSettingsStateContainer
  from '../../commons/components/createSettingsStateContainer';
import createStylesContainer
  from '../../commons/components/createStylesContainer';

// tabs
import MainTab from './MainTab';
import SettingsTab from './SettingsTab';
import HoursTab from './HoursTab';
import BadgesTab from './BadgesTab';
import DesignTab from './DesignTab';
import SupportTab from './SupportTab';
import './Settings.css';

function createSettingsContainer(WrappedComponent) {
  return class extends React.Component {
    constructor(props) {
      super(props);

      this.setActiveTabIndex = this.setActiveTabIndex.bind(this);

      this.state = {
        activeTabIndex: 0
      };
    }

    setActiveTabIndex(activeTabIndex) {
      this.setState(() => ({
        activeTabIndex
      }));
    }

    render() {
      return (
        <WrappedComponent
          {...this.state}
          {...this.props}
          setActiveTabIndex={this.setActiveTabIndex}
        />
      );
    }
  };
}

class Settings extends React.Component {
  render() {
    const {
      data,
      updateData,
      activeTabIndex,
      setActiveTabIndex,
      styles,
      fetchStyles
    } = this.props;

    if (!data) {
      return null;
    }

    let upgradeSection = <span />;

    if (!isPremium()) {
      upgradeSection = (
        <UI.button
          label="Upgrade"
          className="btn-upgrade-nav"
          onClick={() => {
            openBillingPage();
          }}
        />
      );
    }

    return (
      <UI.appSettings>
        <PanelTabs activeTabIndex={activeTabIndex} onChange={setActiveTabIndex}>

          <MainTab
            tab="Main"
            data={data}
            styles={styles}
            onUpdate={updateData}
            onPrimaryButtonClick={() => setActiveTabIndex(1)}
            onSecondaryButtonClick={() => setActiveTabIndex(3)}
            onUpgradeClick={() => {
              openBillingPage();
            }}
          />

          <HoursTab
            tab="Hours"
            data={data}
            styles={styles}
            ref={cmp => this.hoursTabCmp = cmp}
            onActive={() => this.hoursTabCmp && this.hoursTabCmp.reset()}
            onUpdate={updateData}
            onUpgradeClick={() => {
              openBillingPage();
            }}
          />

          <SettingsTab
            tab="Settings"
            data={data}
            styles={styles}
            onUpdate={updateData}
            onUpgradeClick={() => {
              openBillingPage();
            }}
          />

          <BadgesTab
            tab="Signs"
            data={data}
            styles={styles}
            fetchStyles={fetchStyles}
            onUpdate={updateData}
          />

          <DesignTab
            tab="Design"
            data={data}
            styles={styles}
            onUpdate={updateData}
            onUpgradeClick={() => {
              openBillingPage();
            }}
          />

          <hr className="divider-short" />

          <SupportTab
            tab="Support"
            data={data}
            styles={styles}
            onUpdate={updateData}
          />

          {upgradeSection}

        </PanelTabs>
      </UI.appSettings>
    );
  }
}

export default createStylesContainer(
  createSettingsContainer(createSettingsStateContainer(Settings))
);



// WEBPACK FOOTER //
// ./src/apps/settings/Settings.jsx